import { useState } from 'preact/hooks';
import { ImageCard } from '../Image/ImageCard';
import { ImageViewer } from '../Image/ImageViewer';
import type { ChibiImage } from '../../types';

interface GridGalleryProps {
  images: ChibiImage[];
}

export function GridGallery({ images }: GridGalleryProps) {
  const [selectedImage, setSelectedImage] = useState<ChibiImage | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);

  const handleImageClick = (image: ChibiImage, index: number) => {
    setSelectedImage(image);
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setSelectedImage(null);
    setSelectedIndex(-1);
  };

  const handleNext = () => {
    if (selectedIndex < images.length - 1) {
      const newIndex = selectedIndex + 1;
      setSelectedIndex(newIndex);
      setSelectedImage(images[newIndex]);
    }
  };

  const handlePrevious = () => {
    if (selectedIndex > 0) {
      const newIndex = selectedIndex - 1;
      setSelectedIndex(newIndex);
      setSelectedImage(images[newIndex]);
    }
  };

  return (
    <>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-4 pb-20 h-full overflow-y-auto">
        {images.map((image, index) => (
          <ImageCard
            key={image.id}
            image={image}
            onClick={() => handleImageClick(image, index)}
            layout="grid"
          />
        ))}
      </div>

      {selectedImage && (
        <ImageViewer
          image={selectedImage}
          isOpen={!!selectedImage}
          onClose={handleClose}
          onNext={selectedIndex < images.length - 1 ? handleNext : undefined}
          onPrevious={selectedIndex > 0 ? handlePrevious : undefined}
        />
      )}
    </>
  );
}